import { makeStyles } from '@mui/styles';
import { COLOR_WHITE, COLOR_GRAY_30, COLOR_GRAY_90 } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  outerWrapper: {
    padding: '31px 20px 0',
    maxWidth: 1088,
    margin: '0 auto',
    backgroundColor: COLOR_WHITE,

    [theme.breakpoints.up('md')]: {
      paddingLeft: 40,
      paddingRight: 40,
      maxWidth: 1168,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0,
      paddingRight: 0,
      maxWidth: 1088,
    },
  },

  featureWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 15,

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 20,
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },

  featureCard: {
    border: `1px solid ${COLOR_GRAY_30}`,
    borderRadius: 20,
    backgroundColor: COLOR_WHITE,
    padding: '13px 20px 40px',

    [theme.breakpoints.up('md')]: {
      padding: '13px 26px 40px',
    },
  },

  featureTitle: {
    color: COLOR_GRAY_90,
    fontSize: 26,
    fontFamily: 'Lato',
    fontWeight: 600,
    lineHeight: '34px',
    margin: '20px 0 10px',

    [theme.breakpoints.up('md')]: {
      fontWeight: 700,
    },
  },

  featureDescription: {
    color: COLOR_GRAY_90,
    fontSize: 18,
    fontFamily: 'Lato',
    fontWeight: 400,
    lineHeight: '30px',
  },
}));
